import React from 'react';
import { styled } from 'styled-components';
import dayjs from 'dayjs';

import IconCalendar from 'assets/icons/icon_date_calendar.svg';

const Input = styled.input`
  border: none;
  width: 20px !important;
  height: 20px !important;
  cursor: pointer;
  font-size: 14px;

  background: url(${IconCalendar}) center center no-repeat;
  background-size: 20px 20px !important;
  will-change: transform;
  /* background-size: contain; */

  /* 텍스트 숨기기 */
  color: transparent;
  caret-color: transparent; /* 커서가 나타나지 않도록 */
  text-indent: -9999px;

  &::-webkit-calendar-picker-indicator {
    opacity: 0; /* 기본 달력 아이콘 숨기기 */
    cursor: pointer;
  }

  &::-webkit-inner-spin-button {
    display: none; /* 스핀 버튼 숨기기 */
  }

  &::placeholder {
    color: transparent; /* placeholder 색상을 투명하게 */
  }
`;

interface DateInputIProps {
  isMinDate?: boolean;
  maxDate?: string;
  onChange: (e: any) => void;
}

const DateInput: React.FC<DateInputIProps> = props => {
  const { isMinDate, maxDate, onChange } = props;

  return (
    <Input
      type="date"
      min={isMinDate ? undefined : dayjs().format('YYYY-MM-DD')}
      max={maxDate}
      onChange={e => {
        if (maxDate && dayjs(e.target.value).isAfter(dayjs(maxDate), 'day')) {
          window.showToast(
            `${dayjs(maxDate).format(
              'YYYY년 M월 D일',
            )} 이후 날짜는 선택 불가능 합니다.`,
            'failed',
          );

          return;
        }

        if (isMinDate) {
          onChange(e);

          return;
        }

        if (new Date(e.target.value) < new Date()) {
          window.showToast('이전 날짜는 선택 불가능 합니다.', 'failed');

          return;
        }

        onChange(e);
      }}
    />
  );
};

export default DateInput;
